import React from 'react';
import { FormattedMessage } from 'react-intl';
import Breadcrumb from '@/components/breadcrumbs/Breadcrumb';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const DatasetAttachmentsTableTitle = ({ category, code, withDescription }) => {
  const { segments } = Selectors.useDatasetAttachmentsTableTitle({ category, code });
  const onNavigate = Events.useAttachmentFolderNavigate(category, { code });

  return (
    <div>
      <Breadcrumb segments={segments} onNavigate={onNavigate} />
      {(withDescription) && (
        <span className="normal">
          <FormattedMessage id="dataset.attachments.description" />
        </span>
      )}
    </div>
  );
};

export default DatasetAttachmentsTableTitle;
